import Vue from "vue";
import base from "../../../marketing/baseMarketing";

export default Object.assign(
  {
    apiUrl: "/partner/notification/email/",

    edit({
      type,
      data: {
        subject,
        content,
        rawContent,
        cssStyle,
        brief,
        senderName,
        senderEmail,
      },
    }) {
      const url = this.url(type);

      return Vue.http.post(url, {
        subject,
        content,
        rawContent,
        cssStyle,
        brief,
        senderName,
        senderEmail,
      });
    },

    get(type) {
      const url = this.url(type);

      return Vue.http.get(url);
    },

    compile({ type, authToken }) {
      const url = this.url(`${type}/compile`);

      return Vue.http.put(url, authToken, {
        headers: {
          "Content-Type": "text/plain",
        },
      });
    },
  },
  base
);
